//need jquery animation
import './backtotop.css';
class BackToTopComp extends React.Component {
    constructor(props){
        super(props)
        this.state = ({
            show : false
        })
    }
    goTo(){
        /*
        let scrollToTop = window.setInterval(function() {
            let pos = window.pageYOffset;
            if ( pos > 0 ) {
                window.scrollTo( 0, pos - 20 ); // how far to scroll on each step
            } else {
                window.clearInterval( scrollToTop );
            }
        }, 2);
        */
        $("html,body").animate({scrollTop:0},"fast");
    }
    componentDidMount(){
        window.addEventListener('scroll' , ()=>{
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if(scrollTop > 200){
                this.setState({
                    show : true
                })
            }else{
                this.setState({
                    show : false
                })
            }
        })
    }
    render() {
        let { show } = this.state;
        let {img}=this.props;
        if(!img){
            img=BASE_MOBILE_ROOT+'img/common/top.png';
        }
        return (
            <div className="common-back">
                {
                    show &&
                    <div onClick={this.goTo} className="backtotop" style={{'backgroundImage':'url('+img+')'}}></div>
                }

            </div>
        );
    }
}
export default BackToTopComp;